import { Label, Slider } from "@fluentui/react";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FieldContainer } from "../../../../../components/controls/FieldContainer";
import { ErrorMessage } from "../../../../../components/styled";
import { useSelector } from "../../../../../store/hooks";
import { routes } from "config/routes";
import { store } from "store/store";

export const WeightingField = () => {
  // const recommendation = useSelector((s) => s.recommendationPage.rec);
  const [weightingValue, setWeightingValue] = useState(0);
  const [prevSubCategory1Code, setPrevSubCategory1Code] = useState();

  // const userRole = useSelector((s) => s.userRole.userRole);
  // const isWaitingForGreg = recommendation?.recommendationStatusCode === 1;
  // const isWaitingForClient = recommendation?.recommendationStatusCode === 2;
  // const isClosed = recommendation?.recommendationStatusCode === 3;
  const isDisabled = false;
  // (isWaitingForGreg &&
  //   (userRole === "insurer" || userRole === "internal_limited")) ||
  // isWaitingForClient ||
  // isClosed;

  const { t } = useTranslation();
  const { values, setFieldValue, errors } = useFormikContext<any>();
  const subCategory1Code = values?.subCategory1Code;
  const weighting = values?.weighting;
  const defaultValues = useSelector((s) => s.recommendationPage.defaultValues);
  const name = "weighting";

  // when the selected subCategoryCode1 option changes
  // we set the weighting field to the defaultWeighting for that subcategory
  useEffect(() => {
    const loc = store.getState().router.location;
    const addRecommendationMatchPath =
      loc.pathname.includes("add-recommendation");

    if (
      defaultValues.length === 0 ||
      (weighting === undefined && !addRecommendationMatchPath)
    )
      return;

    if (!isDisabled) {
      const dv = defaultValues?.find(
        (dv) => dv.subcategoryCode === subCategory1Code?.value
      );
      let valueToBeSet = weighting ?? 1;
      if (
        prevSubCategory1Code !== undefined &&
        prevSubCategory1Code !== subCategory1Code?.value
      ) {
        valueToBeSet = dv?.defaultWeighting ?? 1;
      }
      setWeightingValue(valueToBeSet);
      setFieldValue(name, valueToBeSet);
      setPrevSubCategory1Code(
        subCategory1Code ? subCategory1Code?.value : null
      );
      return;
    }
  }, [subCategory1Code, defaultValues, isDisabled]);

  const errorId =
    t("ram.recommendationForm.weighting.label").replaceAll(" ", "_") + "_error";

  const hasError = !!errors[name];

  return (
    <div>
      <FieldContainer
        isTooltipHidden={isDisabled}
        tooltipText={t("ram.recommendationForm.weighting.tooltip")}
      >
        <Label required disabled={isDisabled}>
          {t("ram.recommendationForm.weighting.label")}
        </Label>
        <StyledSlider
          min={1}
          max={10}
          snapToStep
          step={1}
          showValue
          value={weightingValue}
          onChange={(value) => {
            setWeightingValue(value);
            setFieldValue(name, value);
          }}
          disabled={isDisabled}
        />
      </FieldContainer>
      {hasError && (
        <ErrorMessage id={errorId}>{errors[name] as string}</ErrorMessage>
      )}
    </div>
  );
};

const StyledSlider = styled(Slider)`
  width: 300px;
  .ms-Slider-slideBox:hover {
    .ms-Slider-inactive {
      background-color: #c7e0f4;
    }
  }
  .ms-Slider-inactive {
    background-color: #c8c6c4;
  }
`;
